import React from 'react';
import { FadeIn } from './FadeIn';
import { Gift } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    num: '01',
    title: 'Pack de Checklists Imprimibles',
    desc: 'Primera consulta · seguimiento · estancamiento · derivación/alertas · adherencia'
  }, {
    num: '02',
    title: 'Planilla de Seguimiento del Paciente',
    desc: 'Peso/medidas/síntomas/energía/hábito clave · para ver progreso más allá de la balanza'
  }, {
    num: '03',
    title: 'Guía de Organización del Consultorio',
    subtitle: '(Tiempo y Agenda)',
    desc: 'Cómo ordenar tu semana y tu sistema de atención para no "vivir trabajando"'
  }, {
    num: '04',
    title: 'Banco de Frases Clínicas',
    desc: 'Frases listas para usar en consulta: motivación, adherencia, límites y más.'
  }, {
    num: '05',
    title: 'Matriz Express',
    desc: 'Herramienta rápida para tomar decisiones clínicas con criterio y velocidad.'
  }, {
    num: '06',
    title: 'Guía de Intervención',
    desc: 'Paso a paso para intervenir en las situaciones más frecuentes del consultorio.'
  }];
  return <section className="pt-4 pb-12 px-4 max-w-5xl mx-auto" data-id="element-15">
      <FadeIn className="text-center mb-8" data-id="element-16">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-mint text-black mb-4" data-id="element-17">
          <Gift size={32} data-id="element-18" />
        </div>
        <h2 className="font-display text-3xl md:text-4xl font-bold text-mint mb-3" data-id="element-19">
          BONOS
        </h2>
        <p className="text-xl font-medium text-mint/70" data-id="element-20">
          (Incluidos — sin costo extra)
        </p>
      </FadeIn>

      <div className="flex flex-col gap-3 max-w-3xl mx-auto" data-id="element-21">
        {bonuses.map((bonus, idx) => <FadeIn key={idx} delay={idx * 0.08} className="bg-surface border border-mint/20 rounded-xl p-4 md:p-5 group hover:border-mint/50 transition-colors" data-id="element-22">
            <div className="flex flex-col sm:flex-row sm:items-center gap-3" data-id="element-23">
              <div className="flex items-center gap-3 flex-1 min-w-0" data-id="element-24">
                <span className="shrink-0 inline-flex items-center justify-center w-10 h-10 rounded-lg bg-mint/15 text-lg" data-id="element-25">
                  🎁
                </span>
                <div className="min-w-0" data-id="element-26">
                  <h3 className="font-bold text-white text-base leading-tight" data-id="element-27">
                    {bonus.title}
                    {bonus.subtitle && <span className="text-mint/60 font-medium text-sm ml-1" data-id="element-28">
                        {bonus.subtitle}
                      </span>}
                  </h3>
                  <p className="text-white/50 text-sm mt-0.5 leading-snug" data-id="element-29">
                    {bonus.desc}
                  </p>
                </div>
              </div>
              <div className="shrink-0 flex items-center gap-2 pl-13 sm:pl-0" data-id="element-30">
                <span className="text-white/30 line-through text-xs" data-id="element-31">
                  $9.000
                </span>
                <span className="text-mint font-[800] text-sm font-['Open_Sans',_sans-serif] uppercase" data-id="element-32">
                  Gratis
                </span>
              </div>
            </div>
          </FadeIn>)}
      </div>
    </section>;
}